export default __webpack_public_path__ + "static/media/fundo.3c77fdac.png";